// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_eS","advertDetailContactGroup__header":"c-n_eT","advertDetailContactGroup__value":"c-n_eU"};